"use strict";

import Vue from 'vue';

/**
 * 埋点
 * 
 * @namespace
 */

let tracking = {
    eventId : {
        TK43 : 'TK43',//借款完成页
        test : 'test'
    }
}

const Plugin = {
    install: function (Vue) {
        Vue.$tracking = tracking;
        window.$tracking = tracking;
        Object.defineProperty(Vue.prototype, '$tracking', {
            value: tracking
        });
    }
};

Vue.use(Plugin);

export default tracking;